// Imodeff property data - initial seed
export const propertiesSeed = [
  {
    slug: 'clos-des-deux-tours',
    title: 'Clos des Deux Tours',
    location: 'Quartier Européen, Bruxelles',
    category: 'developments',
    status: 'new-projects',
    price: null,
    hero: 'https://images.pexels.com/photos/23947751/pexels-photo-23947751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    images: [
      'https://images.pexels.com/photos/23947751/pexels-photo-23947751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.pexels.com/photos/26838218/pexels-photo-26838218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.pexels.com/photos/18587809/pexels-photo-18587809.jpeg'
    ],
    description: 'A landmark residential project in the heart of the European Quarter combining contemporary architecture, thermal performance and refined interiors. The development offers 42 apartments ranging from studios to penthouses, with private gardens on the ground floor and generous terraces on the upper levels.',
    surface: '3 500 m²',
    units: 42,
    year: 2024,
    architect: 'A2M Architects',
    features: ['Underground parking', 'Private gardens', 'Energy label A', 'Elevator access', 'Bicycle storage']
  },
  {
    slug: 'zara-alost',
    title: 'Zara Alost',
    location: 'Alost',
    category: 'developments',
    status: 'new-projects',
    hero: 'https://images.pexels.com/photos/26838218/pexels-photo-26838218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    images: [
      'https://images.pexels.com/photos/26838218/pexels-photo-26838218.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.pexels.com/photos/35339499/pexels-photo-35339499.jpeg'
    ],
    description: 'A refined mixed-use development in central Alost, combining a flagship retail space on the ground floor with high-end residential apartments above. Careful attention was paid to the historical facade while introducing modern glazing and passive-house standards.',
    surface: '2 100 m²',
    units: 18,
    year: 2023,
    architect: 'Buro II & Archi+I',
    features: ['Retail on ground floor', 'Rooftop terrace', 'Passive standard', 'City-center location']
  },
  {
    slug: 'residence-green-park',
    title: 'Résidence Green Park',
    location: 'Embourg',
    category: 'developments',
    status: 'for-sale',
    price: 'From € 385 000',
    hero: 'https://images.pexels.com/photos/1488267/pexels-photo-1488267.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    images: [
      'https://images.pexels.com/photos/1488267/pexels-photo-1488267.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
      'https://images.pexels.com/photos/16573669/pexels-photo-16573669.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
    ],
    description: 'Green Park is a boutique development of 12 apartments set within a mature landscaped park in Embourg. Each unit benefits from a south-facing terrace and views over the surrounding greenery.',
    surface: '1 800 m²',
    units: 12,
    year: 2022,
    features: ['Landscaped gardens', 'South-facing terraces', 'Underground parking', 'Fibre-optic ready']
  },
  {
    slug: 'residence-four-seasons',
    title: 'Résidence Four Seasons',
    location: 'Embourg',
    category: 'developments',
    status: 'for-sale',
    price: 'From € 420 000',
    hero: 'https://images.unsplash.com/photo-1448630360428-65456885c650',
    images: [
      'https://images.unsplash.com/photo-1448630360428-65456885c650',
      'https://images.pexels.com/photos/12029115/pexels-photo-12029115.jpeg'
    ],
    description: 'A contemporary residence of 16 apartments offering the highest levels of finish and energy efficiency. Four Seasons has been designed to remain comfortable year-round, with cross-ventilation, geothermal heating and a rain-water collection system.',
    surface: '2 400 m²',
    units: 16,
    year: 2023,
    features: ['Geothermal heating', 'Rain-water collection', 'Home automation', 'Premium finishes']
  },
  {
    slug: 'g-legrand',
    title: 'G. Legrand',
    location: 'Embourg',
    category: 'developments',
    status: 'assets',
    hero: 'https://images.pexels.com/photos/19445290/pexels-photo-19445290.jpeg',
    images: ['https://images.pexels.com/photos/19445290/pexels-photo-19445290.jpeg'],
    description: 'A restrained and elegant residence on avenue Legrand, blending seamlessly with the surrounding villas.',
    surface: '1 400 m²',
    units: 8,
    year: 2019,
    features: ['Private parking', 'Elevator', 'Refined common areas']
  },
  {
    slug: 'residence-curvers',
    title: 'Résidence Curvers',
    location: 'Embourg',
    category: 'investments',
    status: 'assets',
    hero: 'https://images.pexels.com/photos/36437903/pexels-photo-36437903.jpeg',
    images: ['https://images.pexels.com/photos/36437903/pexels-photo-36437903.jpeg'],
    description: 'A signature address managed by Imodeff, hosting long-term tenants who value quality and location.',
    surface: '1 600 m²',
    units: 10,
    year: 2015,
    features: ['Fully leased', 'On-site concierge', 'Landscaped gardens']
  },
  {
    slug: 'residence-du-golf',
    title: 'Résidence du Golf',
    location: 'Beaufays',
    category: 'developments',
    status: 'for-rent',
    price: '€ 1 450 / month',
    hero: 'https://images.pexels.com/photos/27075286/pexels-photo-27075286.jpeg',
    images: ['https://images.pexels.com/photos/27075286/pexels-photo-27075286.jpeg'],
    description: 'Overlooking the Beaufays golf course, this residence offers a serene setting only 15 minutes from central Liège.',
    surface: '1 900 m²',
    units: 14,
    year: 2020,
    features: ['Golf-course view', 'Two-car parking', 'Storage cellar', 'Furnished option']
  },
  {
    slug: 'residence-grand-air',
    title: 'Résidence Grand Air',
    location: 'Beaufays',
    category: 'developments',
    status: 'for-rent',
    price: '€ 1 250 / month',
    hero: 'https://images.unsplash.com/photo-1515263487990-61b07816b324',
    images: ['https://images.unsplash.com/photo-1515263487990-61b07816b324'],
    description: 'Bright and quiet apartments in a small residence surrounded by nature. Ideal for a peaceful family life close to the city.',
    surface: '1 300 m²',
    units: 9,
    year: 2018,
    features: ['Large terraces', 'Family-friendly', 'Bicycle storage']
  }
];

export const teamSeed = [
  {
    name: 'Dimitri Hodjeff',
    role: 'Owner',
    image: '/assets/dimitri.png'
  },
  {
    name: 'Tatiana Hodjeff',
    role: 'Managing Director',
    image: '/assets/tatiana.png',
    email: 'tatiana@imargo.be',
    phone: '+32 498 19 67 20'
  }
];
